// Dependencies
import Vue from 'vue'
import Router from 'vue-router'
import CoreRoutes from './routes.js'
import ThemeRoutes from '@/app-theme/router/routes.js'

if (window.location.href.endsWith('//')) {
  window.location.href = window.location.href.replace(/\/+$/, '')
}

Vue.use(Router)

const AppRoutes = {
  SimpleRoutes: [...(ThemeRoutes?.SimpleRoutes || []), ...CoreRoutes.SimpleRoutes],
  LangRoutes  : [...(ThemeRoutes?.LangRoutes || []), ...CoreRoutes.LangRoutes]
}

const createRouter = () => new Router({
  mode  : 'history',
  base  : import.meta.env.VITE_PUBLIC_PATH,
  routes: [],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el      : to.hash,
        behavior: 'smooth'
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      if (to.params.tab || to.params.subTab) return
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  const routes = [
    {
      path     : '/:lang',
      props    : true,
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: AppRoutes.LangRoutes
    },
    ...AppRoutes.SimpleRoutes
  ]

  routes.forEach(route => router.addRoute(route))
}

const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}

export default router
